import AstellasLogo from '../../assets/images/onboardPage/astellas_logo.png'
import { Box, Button, Typography } from "@mui/material"
import { theme } from "../../utils/theme/godzilla_light"
import { useNavigate } from "react-router-dom"
import { useAppContext, useAuth } from "../../contexts"
import { useTranslation } from 'react-i18next'
import TransMsg from './transMessage'

export const NotFound = () => {
     const { t } = useTranslation();
    const navigate = useNavigate();
    const { userData } = useAppContext()
    const { logout } = useAuth();

    const handleNav = () => {
        if (userData?.isNpiVerified) {
            navigate("/home")
        }
        else {
            logout()
        }
    }

    return (
        <Box sx={{ py: "30px", px: "180px" }}>
            <img src={AstellasLogo} style={{ height: "4rem", width: "14rem" }} alt="not-found-logo" />
            <Box my={"1rem"} pl={"40px"}>
                <Typography style={{ ...theme.typography.montseratH1 }}>{t(TransMsg.STATUS_CODE)}</Typography>
                <Typography style={{ ...theme.typography.montseratBodySemiBold, fontSize: "20px" }}>{t(TransMsg.PAGE_NOT_FOUND_TITLE)}</Typography>
                <Typography style={{ ...theme.typography.montseratBodyRegular2, marginTop: "1rem" }}>{t(TransMsg.PAGE_NOT_FOUND_DESCRIPTION)}</Typography>
            </Box>
            <Button
                variant="contained"
                onClick={handleNav}
                style={{ width: "220px" ,marginLeft:"40px"}}>
                <Typography style={{ ...theme.typography.components.montseratButtonContainedLabel }}>
                    {userData?.isNpiVerified ? t(TransMsg.GOT_TO_HOME) : t(TransMsg.GOT_TO_LOGIN)}
                </Typography>
            </Button>
        </Box>
    )
}